// extracted by mini-css-extract-plugin
export default {"pageWrap":"sd-z","fullWidth":"td-z","heading":"ud-z","fullBleed":"vd-z","hidden":"wd-z"};